import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CrcPipe } from '../../../../shared/pipes/crc.pipe';
import type { Product } from '../../../../shared/models/product.model';
import { BLOG_COPY } from '../../constants/blog.constants';
import { toBlogProductView } from '../../utils/blog-links.util';

/**
 * Producto mencionado en una sección del artículo (B34 (b)).
 *
 * Sin botón «Agregar» (B70): emitía `addToCart` y nadie lo escuchaba, así que
 * el clic se perdía. Vuelve cuando se cablee la compra real con la API (P17).
 * Mientras, el nombre lleva a la ficha si el producto es navegable.
 */
@Component({
  selector: 'app-article-inline-product',
  imports: [RouterLink, CrcPipe],
  templateUrl: './article-inline-product.component.html',
  styleUrl: './article-inline-product.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleInlineProductComponent {
  product = input.required<Product>();

  protected readonly copy = BLOG_COPY;
  protected readonly view = computed(() => toBlogProductView(this.product()));
}
